import { styled } from "styled-components";
import { PopupBtn } from "@template/components/Popup/styles.ts";

export const SearchTabContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  position: relative;
`;

export const SearchGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`;

export const SearchInput = styled.div`
  width: 100%;
  display: flex;
  gap: 4px;
  align-items: flex-start;
  ${PopupBtn} {
    width: fit-content;
    min-width: 180px;
  }
`;

export const SearchButton = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
`;

export const Alert = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: 48px;
  background: transparent;
  bottom: 0;
  left: 0;
  color: ${({ theme }) => theme.colors.primary.default};
`;

export const Container = styled.div`
  width: 100%;
`;

export const SuggestionList = styled.ul`
  background: white;
  border: 1px solid ${({ theme }) => theme.colors.default[50]};
  border-radius: 4px; /* Added for better design match */
  list-style: none;
  margin: 4px 0 0 0; /* Add a tiny gap from the input */
  padding: 0;
  max-height: 250px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* Adds depth over other content */
  z-index: 9999; /* High z-index to stay on top */
`;

export const SuggestionItem = styled.li`
  padding: 12px 15px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.colors.default[50]};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.default[100]};
    color: ${({ theme }) => theme.colors.primary.default};
  }
`;

export const Highlight = styled.span`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary.default};
  border-radius: 2px;
`;
